module.exports = __webpack_public_path__ + "static/img/9.3672e2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/9.png
// module id = A147
// module chunks = 1